const E = {
  'Current Users': 'Current Users',
  'Create User': 'Create User',
  'Inactive Users': 'Inactive Users',

  'no users': 'no users',
  'Edit User\nInformation': 'Edit User\\nInfo',
  'Edit User\nAccess': 'Edit User\\nAccess',
  Deactivate: 'Deactivate',
  UserInformation: 'User Information',
  'Edit User Information': 'Edit User Info',
  'Back to Users': 'Back to Users',
  'User Information': 'User Information',
  'Edit User Access': 'Edit User Access',

  'First Name': 'Name',
  'Last Name': 'Last Name',
  'Work Email (User ID)': 'Work Email (User ID)',
  Password: 'Password',
  Phone: 'Phone',
  Ext: 'Ext',
  'Password Expiry Date': 'Password Expiry Date',
  'Work For': 'Work For',
  'Select Company': 'Select Company',
  'Language Preference': 'Language Preference',
  Cancel: 'Cancel',
  Save: 'Save',

  'Create New Scenario': 'Create New Scenario',
  'Please select Company': 'Please select Company',
  'Please select Project Number': 'Please select Project Number',
  'Attention To': 'Attention To',
  'Please select Attention To': 'Please select Attention To',
  'Please select Report To': 'Please select Report To',
  'Please select Site': 'Please select Site',
  Add: 'Add',
  'Available Scenarios': 'Available Scenarios',
  Assign: 'Assign',
  'Scenarios Assigned To User': 'Scenarios Assigned To User',
  Remove: 'Remove',
  Reactivate: 'Reactivate',
  'no inactive users': 'No inactive users found.',
  EditUserInformation: 'Edit User Information',
  EditUserAccess: 'Edit User Access',
  UserName: 'User Name',
  LoginId: 'Login ID',
  LastLogin: 'Last Login',
  CurrentUsers: 'Current Users',
  InactiveUsers: 'Inactive Users',
  ConfirmPassword: 'Confirm Password',

  'Access Type': 'Access Type',
  'Company Name': 'Company Name',
  Facility: 'Facility',
  'Report To': 'Report To',
  'Project #': 'Project #',
  Site: 'Site',
  Attention: 'Attention',
  'Assign All': 'Assign All',
  'Delete All': 'Delete All',
  "Split Reports": "Split Reports",
  'Job Edits': "Job Edits",
};

const F = {
  'Current Users': 'Utilisateurs actuels',
  'Create User': 'Créer un utilisateur',
  'Inactive Users': 'Utilisateurs inactifs',

  'no users': 'Aucun utilisateur',
  'Edit User\nInformation': 'Modifier les\\ninformations\\nutilisateur',
  'Edit User\nAccess': 'Modifier\\nl\'accès\\nutilisateur',
  EditUserAccess: 'Modifier nl\'accès utilisateur',
  Deactivate: 'Désactiver',
  UserInformation: 'Informations utilisateur',
  'Edit User Information': 'Modifier infos utilisateur',
  'Back to Users': 'Revenir aux utilisateurs',
  'User Information': 'Informations utilisateur',
  'Edit User Access': 'Modifier l’accès utilisateur',

  'First Name': 'Prenom et Nom',
  'Last Name': 'Nom',
  'Work Email (User ID)': 'Adresse courriel professionnelle (ID utilisateur) ',
  Password: 'Mot de passe',
  ConfirmPassword: 'Confirmer le mot de passe',
  Phone: 'Téléphone',
  Ext: 'Poste',
  'Password Expiry Date': 'Expiration du mot de passe ',
  'Work For': 'Travaille pour',
  'Select Company': 'Sélectionner entreprise ',
  'Language Preference': 'Langues',
  Cancel: 'Annuler',
  Save: 'Enregistrer',

  'Create New Scenario': 'Créer un nouveau scénario',
  'Please select Company': 'Veuillez sélectionner une entreprise',
  'Please select Project Number': 'Veuillez sélectionner un numéro de projet',
  'Attention To': 'À l’attention de',
  'Please select Attention To': 'Veuillez sélectionner un destinataire',
  'Please select Report To': 'Veuillez sélectionner un destinataire',
  'Please select Site': 'Veuillez sélectionner un site',
  Add: 'Ajouter',
  'Available Scenarios': 'Scénarios disponibles',
  Assign: 'Attribuer',
  'Scenarios Assigned To User': 'Scénarios attribués à l’utilisateur',
  Remove: 'Supprimer',
  Reactivate: 'Réactiver',
  'no inactive users': 'Aucun utilisateur inactif.',
  EditUserInformation: 'Modifier les infos utilisateur',
  UserName: 'Nom d’utilisateur',
  LoginId: 'ID connexion',
  LastLogin: 'Dernière connexion',
  CurrentUsers: 'Utilisateurs actuels',
  InactiveUsers: 'Utilisateurs inactifs',

  'Access Type': 'Type d\'accès',
  'Company Name': 'Nom de l\'entreprise',
  Facility: 'Installations',
  'Report To': 'Envoyer le rapport à',
  'Project #': 'Numéro de projet',
  Site: 'Site',
  Attention: 'À l’attention de',
  'Assign All': 'Attribuer tout',
  'Delete All': 'Supprimer tout',
  "Split Reports": 'Rapports fractionnés',
  'Job Edits': "Job Edits",
};

export default { E, F };



// WEBPACK FOOTER //
// ./src/constants/translations/manageAccess.js